import { useAuth0 } from '@auth0/auth0-react';
import { SingleFadeLoader } from 'components/SingleFadeLoader';
import { Navigate } from 'react-router-dom';

interface LoginProps {
  firstEnabledPath: string | null;
}

/**
 *
 * @returns  JSX.Element
 *
 * This component is used to redirect the user to the fleet overview page
 * if they are authenticated. Otherwise, it renders an empty div as the user
 * is redirected to the Auth0 login page.
 */
function LoginView({ firstEnabledPath }: LoginProps): JSX.Element {
  const { isAuthenticated } = useAuth0();

  if (isAuthenticated) {
    if (firstEnabledPath) {
      return <Navigate to={firstEnabledPath} replace />;
    } else {
      return <SingleFadeLoader isFullScreen={true} />;
    }
  }

  return <div className="App"></div>;
}

export default LoginView;
